import React from 'react'
import { Link } from 'react-router-dom'
import './footer.css'

const GOOGLE_MAPS_DIRECTIONS_URL =
  'https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQRRg5MgYIAhAjGCcyDwgDEC4YQxixAxiABBiKBTIHCAQQABiABDIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPdIBCDEyMDFqMGo3qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=tr&sa=X&geocode=KcO3fGSQt8oUMU8tXf2eHzZ-&daddr=Conrad+%C4%B0stanbul+Bosphorus+Otopark%C4%B1,+Cihann%C3%BCma,+Saray+Cd+No:5,+34351+Be%C5%9Fikta%C5%9F/%C4%B0stanbul'

const Footer = () => {
  return (
    <footer className="editorial-footer-root">
      {/* Üst Editorial Izgara (4 Kolon) */}
      <div className="editorial-footer-container">
        <div className="editorial-footer-grid">
          {/* Kolon 1: Marka & Stüdyo */}
          <div className="footer-col footer-col-brand">
            <Link to="/" className="footer-brand-logo-link" aria-label="Ateş Auto Detailing Ana Sayfa">
              <img
                src="/logo.png"
                alt="ATEŞ AUTO DETAILING Logo"
                className="footer-brand-logo-img"
              />
            </Link>
            <span className="footer-brand-title">ATEŞ AUTO DETAILING</span>
            <p className="footer-brand-desc">
              İstanbul Beşiktaş&apos;ta premium araç kaplama, PPF, seramik kaplama ve detailing uygulamaları.
            </p>
            <div className="footer-location-block">
              <span className="footer-location-badge">STÜDYO KONUMU</span>
              <address className="footer-address">
                Conrad İstanbul Bosphorus Otoparkı<br />
                Cihannüma Mahallesi, Saray Caddesi No:5<br />
                34351 Beşiktaş / İstanbul
              </address>
              <a
                href={GOOGLE_MAPS_DIRECTIONS_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="footer-directions-btn"
                aria-label="Google Haritalar'da yol tarifi al"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polygon points="3 11 22 2 13 21 11 13 3 11" />
                </svg>
                <span>Yol Tarifi Al</span>
              </a>
            </div>
          </div>

          {/* Kolon 2: Hizmetlerimiz (12 Çekirdek Rota) */}
          <div className="footer-col footer-col-services">
            <h4 className="footer-col-title">HİZMETLERİMİZ</h4>
            <div className="footer-services-subgrid">
              <ul className="footer-links-list">
                <li>
                  <Link to="/arac-koruma" className="footer-link">Araç Koruma</Link>
                </li>
                <li>
                  <Link to="/ppf-kaplama" className="footer-link">PPF Kaplama</Link>
                </li>
                <li>
                  <Link to="/arac-kaplama" className="footer-link">Araç Kaplama</Link>
                </li>
                <li>
                  <Link to="/boya-koruma" className="footer-link">Boya Koruma</Link>
                </li>
                <li>
                  <Link to="/seramik-kaplama" className="footer-link">Seramik Kaplama</Link>
                </li>
                <li>
                  <Link to="/detayli-arac-temizligi" className="footer-link">Detaylı Araç Temizliği</Link>
                </li>
              </ul>
              <ul className="footer-links-list">
                <li>
                  <Link to="/boya-duzeltme" className="footer-link">Boya Düzeltme</Link>
                </li>
                <li>
                  <Link to="/polisaj" className="footer-link">Polisaj</Link>
                </li>
                <li>
                  <Link to="/far-parlatma" className="footer-link">Far Parlatma</Link>
                </li>
                <li>
                  <Link to="/cam-filmi" className="footer-link">Cam Filmi</Link>
                </li>
                <li>
                  <Link to="/buharli-arac-temizligi" className="footer-link">Buharlı Araç Temizliği</Link>
                </li>
                <li>
                  <Link to="/detayli-motor-temizligi" className="footer-link">Detaylı Motor Temizliği</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Kolon 3: Keşfet & Kurumsal */}
          <div className="footer-col footer-col-nav">
            <h4 className="footer-col-title">KEŞFET</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="/projeler" className="footer-link">Projeler</Link>
              </li>
              <li>
                <Link to="/galeri" className="footer-link">Stüdyo Galerisi</Link>
              </li>
              <li>
                <Link to="/blog" className="footer-link">Detailing Rehberi (Blog)</Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="footer-link">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/iletisim" className="footer-link">İletişim &amp; Randevu</Link>
              </li>
            </ul>
          </div>

          {/* Kolon 4: İletişim & WhatsApp Dönüşüm CTA */}
          <div className="footer-col footer-col-contact">
            <h4 className="footer-col-title">İLETİŞİM &amp; RANDEVU</h4>
            <div className="footer-phones">
              <a href="tel:05346442153" className="footer-phone-link">
                <span className="footer-phone-prefix">MOBİL / WHATSAPP:</span>
                <span className="footer-phone-number">0534 644 21 53</span>
              </a>
              <a href="tel:02124412153" className="footer-phone-link">
                <span className="footer-phone-prefix">STÜDYO TELEFON:</span>
                <span className="footer-phone-number">0212 441 21 53</span>
              </a>
            </div>

            <div className="footer-hours-block">
              <span className="footer-hours-label">ÇALIŞMA SAATLERİ</span>
              <p className="footer-hours-text">
                Pazartesi – Cumartesi: 08:30 – 19:00<br />
                Pazar: Kapalı
              </p>
            </div>

            {/* Premium WhatsApp CTA */}
            <div className="footer-cta-wrapper">
              <a
                href="https://wa.me/905346442153"
                target="_blank"
                rel="noreferrer noopener"
                className="footer-whatsapp-cta"
                aria-label="WhatsApp üzerinden randevu ve bilgi alın"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                  className="footer-whatsapp-icon"
                >
                  <path d="M18.497 4.409a10 10 0 0 1-10.36 16.828l-.223-.098l-4.759.849l-.11.011a1 1 0 0 1-.11 0l-.102-.013l-.108-.024l-.105-.037l-.099-.047l-.093-.058l-.014-.011l-.012-.007l-.086-.073l-.077-.08l-.067-.088l-.056-.094l-.034-.07l-.04-.108l-.028-.128l-.012-.102a1 1 0 0 1 0-.125l.012-.1l.024-.11l.045-.122l1.433-3.304l-.009-.014A10 10 0 0 1 5.056 4.83l.215-.203a10 10 0 0 1 13.226-.217M9.5 7.5A1.5 1.5 0 0 0 8 9v1a6 6 0 0 0 6 6h1a1.5 1.5 0 0 0 0-3h-1l-.144.007a1.5 1.5 0 0 0-1.128.697l-.042.074l-.022-.007a4.01 4.01 0 0 1-2.435-2.435l-.008-.023l.075-.041A1.5 1.5 0 0 0 11 10V9a1.5 1.5 0 0 0-1.5-1.5" />
                </svg>
                <div className="footer-cta-text-group">
                  <span className="footer-cta-sub">RANDEVU &amp; BİLGİ AL</span>
                  <span className="footer-cta-main">WhatsApp&apos;tan Yaz</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Alt Footer & Yasal Bilgi */}
      <div className="editorial-footer-bottom">
        <div className="editorial-footer-bottom-inner">
          <div className="footer-bottom-brand">
            <span>ATEŞ AUTO DETAILING</span>
            <span className="footer-dot-sep">•</span>
            <span>© 2026 Tüm Hakları Saklıdır.</span>
          </div>

          <div className="footer-bottom-links">
            <Link to="/terms-conditions" className="footer-legal-link">
              Şartlar &amp; Koşullar
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
